import React from 'react';

import { Card, TitleText, CardFooter, SubTitleText, NoticeText } from './Styled';

export const Content = ({ children, ...props }) => (
  <Card {...props}>{children}</Card>
);

export const Title = ({ className, children, color }) => (
  <TitleText className={className} color={color}>{children}</TitleText>
);

export const SubTitle = ({ children, ...props }) => (
  <SubTitleText {...props}>{children}</SubTitleText>
);

export const Notice = ({ children, ...props }) => (
  <NoticeText {...props}>{children}</NoticeText>
);

export const Header = ({ className, children }) => (
  <Card className={className}>{children}</Card>
);

export const Footer = ({ children }) => <CardFooter>{children}</CardFooter>;
